export type ABTestingMatrix = {
  accountEnabled?: boolean;
  darkUiTheme?: ABTestingDarkUiTheme;
  lightUiTheme?: ABTestingLightUiTheme;
  liveEditTogether?: LiveEditTogetherVariant;
  promptPreferencesSnackbar?: PromptPreferencesSnackbarVariant;
};

// Mirrors `DarkModeUITheme` rather than reusing it: the matrix is the remote config
// contract, and preferences already reads this module for its initial theme, so
// importing back the other way would close a cycle between the two features.
export enum ABTestingDarkUiTheme {
  ClassicDark = "ClassicDark",
  SportyDark = "SportyDark",
  Stadium = "Stadium",
  ChalkTalkDark = "ChalkTalkDark",
  PlaybookPrintDark = "PlaybookPrintDark",
  BroadcastDark = "BroadcastDark",
}

export enum ABTestingLightUiTheme {
  ClassicLight = "ClassicLight",
  Turf = "Turf",
  Whiteboard = "Whiteboard",
  Notebook = "Notebook",
  ChalkTalkLight = "ChalkTalkLight",
  PlaybookPrintLight = "PlaybookPrintLight",
  BroadcastLight = "BroadcastLight",
}

/**
 * Variations of the snackbar prompting the user to set up their preferences,
 * tested against the current wording — which stays the control group and is what
 * an unassigned user gets. Every arm but `Persistent` varies the copy alone.
 */
export enum PromptPreferencesSnackbarVariant {
  AddPlayers = "AddPlayers",
  AddPlayersQuickSetup = "AddPlayersQuickSetup",
  Theme = "Theme",
  Ownership = "Ownership",
  Persistent = "Persistent",
}

/**
 * Framings of the not-yet-built live editing feature, offered as an entry point that
 * only announces itself, so the click-through measures demand before anything is built.
 * Unlike the other parameters there is no control wording: an unassigned user is the
 * holdout and gets no entry point at all.
 */
export enum LiveEditTogetherVariant {
  LiveEditTogether = "LiveEditTogether",
  Collaborate = "Collaborate",
  InviteCoach = "InviteCoach",
}
